<template>
    <div class="tw:flex tw:flex-col tw:gap-4 tw:pb-4">
        <!-- tipo_svg=2: SeccionesComponent (sections hierarchy / Leaflet 3D) -->
        <SeccionesComponent
            v-if="tipoSvg === 2"
            :hide-header="true"
            @terminar="onTerminar"
        />
        <!-- tipo_svg=1 (or null): Flat zones with venue map + table -->
        <template v-else>
            <VenueMapCard
                :svg-markup="svgRecinto"
                :zones="zonas"
                :selected-zone-id="zonaSeleccionada?.id ?? null"
                :loading="loadingZonas"
                @zone-click="onSelectZona"
            />
            <ZoneTableCard
                :zones="zonas"
                :loading="loadingZonas"
                :title="$t('perfil.cambio_asiento.listado_sectores')"
                @select="onSelectZona"
            />
        </template>
    </div>
</template>

<script setup>
    import SeccionesComponent from '@/components/frontend/abonos/nuevo/SeleccionarAsientoConSecciones/SeccionesComponent.vue';
    import VenueMapCard from '@/modules/front/ticketing/VenueMapCard.vue';
    import ZoneTableCard from '@/modules/front/ticketing/ZoneTableCard.vue';

    defineProps({
        /** Tipo de SVG del recinto: 1 = asientos normales, 2 = Leaflet 3D */
        tipoSvg: {
            type: Number,
            default: null,
        },
        /** SVG del recinto (para VenueMapCard en tipo_svg=1) */
        svgRecinto: {
            type: String,
            default: '',
        },
        /** Listado de zonas planas (para VenueMapCard/ZoneTableCard en tipo_svg=1) */
        zonas: {
            type: Array,
            default: () => [],
        },
        /** Indica si se están cargando las zonas */
        loadingZonas: {
            type: Boolean,
            default: false,
        },
        /** Zona actualmente seleccionada por el usuario */
        zonaSeleccionada: {
            type: Object,
            default: null,
        },
    });

    const emit = defineEmits(['seleccionar-zona']);

    /**
     * Cuando el usuario selecciona una región/zona en SeccionesComponent,
     * emitimos el evento para que el composable la asigne como zona seleccionada.
     */
    function onTerminar(zona) {
        emit('seleccionar-zona', zona);
    }

    /**
     * Cuando el usuario selecciona una zona en VenueMapCard o ZoneTableCard,
     * emitimos el evento para que el composable la asigne como zona seleccionada.
     */
    function onSelectZona(zona) {
        emit('seleccionar-zona', zona);
    }
</script>
